// @flow weak

import React, {
  PureComponent
}                     from 'react';
import PropTypes      from 'prop-types';
import AnimatedView   from '../../components/animatedView/AnimatedView';
import { button, Link, BrowserRouter, Route, Switch, Redirect, withRouter } from 'react-router-dom';

class Search extends PureComponent {
  constructor(props) {
    super(props);
    //console.log(props.match.params.file);
    this.state = {
			keyword: '',
    };
  }

  componentDidMount() {
  }

  componentWillUnmount() {
  }

  submit(e) {
    e.preventDefault();
    this.props.history.push({
      pathname: `/search/${this.state.keyword}`
    });
    this.refs.search.value = '';
  }

  onChange(e) {
    this.setState({keyword: e.target.value});
  }

  render() {
    return(
      <form id="searchForm" onSubmit={this.submit.bind(this)}>
        <div>
          <input type="text" id="search" ref="search" className="form-control" onChange={this.onChange.bind(this)} placeholder="Global Search" autoComplete="off" />
          <i className="fa fa-search" onClick={this.submit.bind(this)}></i>
        </div>
      </form>
    );
  }
}

export default withRouter(Search);



// WEBPACK FOOTER //
// ./src/app/views/search/Search.js